/* app/js/src/components/common/collapsible/collapsible.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host .container {
  border-bottom: solid 1px #e1e6eb;
}
:host:first-of-type .container {
  border-top: solid 1px #e1e6eb;
}
.container {
  padding-left: 3%;
  padding-right: 3%;
}
.container header {
  height: 53px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.container.open {
  background-color: #f1f3f4;
  padding-bottom: 24px;
}
.label {
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #232f3a;
  font-weight: bold;
}
.button {
  color: #7d8fa1;
  text-decoration: underline;
  font-size: 12px;
}
/*# sourceMappingURL=collapsible.component.css.map */
